import { Modal, Form, Select, Input, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const FieldFilterModal = ({
  disabled,
  open,
  setOpen,
  filterForm,
  fieldPath,
  handleFieldMappingChange,
  onValuesChange,
}) => {
  return (
    <Modal
      centered
      title="篩選條件"
      open={open}
      okButtonProps={{ autoFocus: true, htmlType: "submit" }}
      onCancel={() => setOpen(false)}
      modalRender={(dom) => (
        <Form
          form={filterForm}
          disabled={disabled}
          layout="vertical"
          requiredMark={false}
          onValuesChange={onValuesChange}
          onFinish={(values) => {
            handleFieldMappingChange(
              fieldPath + ".source.filterConditions",
              values
            );
            setOpen(false);
          }}
        >
          {dom}
        </Form>
      )}
      styles={{
        body: {
          paddingTop: "20px",
          maxHeight: "80vh",
          overflowY: "auto",
        },
      }}
    >
      <Form.List name="conditions">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <div
                key={key}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                }}
              >
                {key}
                <Form.Item
                  {...restField}
                  name={[name, "operation"]}
                  label="運算元"
                  rules={[{ required: true }]}
                  style={{ width: "20%" }}
                >
                  <Select
                    options={[
                      { value: "largerThan", label: ">" },
                      { value: "smallerThan", label: "<" },
                      { value: "equals", label: "等於" },
                      { value: "notEquals", label: "不等於" },
                      { value: "contains", label: "包含" },
                      { value: "notContains", label: "不包含" },
                      { value: "null", label: "空值" },
                      { value: "notNull", label: "非空值" },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "value"]}
                  label="條件"
                  rules={[{ required: true, message: "請填寫篩選條件" }]}
                  style={{ width: "80%" }}
                >
                  <Input placeholder="篩選條件" />
                </Form.Item>
                <MinusCircleOutlined
                  onClick={() => remove(name)}
                  style={{ color: "red" }}
                />
              </div>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add({ operation: "largerThan", condition: "" })}
                block
                icon={<PlusOutlined />}
              >
                新增篩選條件
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item name="note" label="備註">
        <Input placeholder="可利用條件序號協助詳述，例如：(0 and 1) or (3 and 4)" />
      </Form.Item>
    </Modal>
  );
};

export default FieldFilterModal;
